<template>
  <!-- ========== Left Sidebar Start ========== -->
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ item.label }}
        </li>
        <template v-if="item.empresaRequired === false || (currenEmpresa && currenEmpresa.eco_codigo)">
          <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
            <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent"
               :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
              <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
              <span>{{ item.label }}</span>
              <span :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                    v-if="item.badge">{{ item.badge.text }}</span>
            </a>
            <router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref">
              <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
              <span>{{ item.label }}</span>
              <span :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                    v-if="item.badge">{{ item.badge.text }}</span>
            </router-link>
            <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
              <li v-for="(subitem, index) of item.subItems" :key="index">
                <router-link :to="subitem.link" v-if="!hasItems(subitem)" class="side-nav-link-ref">{{
                    subitem.label
                  }}
                </router-link>
                <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow"
                   href="javascript:void(0);">{{ subitem.label }}</a>
                <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                  <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                    <router-link :to="subSubitem.link" class="side-nav-link-ref">{{ subSubitem.label }}</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </template>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>

<script>
import MetisMenu from "metismenujs/dist/metismenujs";

import {menuItems} from "./menu";
import {menuAdminItems} from "./menu-admin";

export default {
  data() {
    return {
      menuData: null,
    };
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    let menuRef = new MetisMenu("#side-menu");
    let links = document.getElementsByClassName("side-nav-link-ref");
    let matchingMenuItem = null;
    const paths = [];

    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    let itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      let parent = matchingMenuItem.parentElement;

      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            let childAnchor = parent3.querySelector(".has-arrow");
            let childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  computed: {
    currenEmpresa() {
      if (this.$store) {
        return this.$store.state.auth.currenEmpresa;
      } else {
        return null;
      }
    },
    menuItems() {
      if (!this.$store) {
        return [];
      }

      // Cópia profunda da fonte para nunca mutar o array de módulo compartilhado.
      let items = JSON.parse(JSON.stringify(menuItems));

      // Itens de administração
      if (this.$store.state.auth.currentUser.aut_access === 'A') {
        const retornoPagamento = (this.$store.state.auth.currentEntidade.par_tipo_cobranca === '2' || this.$store.state.auth.currentEntidade.par_chave_pix);
        const menuAdmin = menuAdminItems();
        items.push(menuAdmin.cabecalho, ...menuAdmin.itensAdmin);
        if (!retornoPagamento) {
          const gestao = items.find(x => x.id === 99992);
          if (gestao && gestao.subItems) {
            gestao.subItems = gestao.subItems.filter(c => c.id !== 999924);
          }
        }
      }

      // Filtragem por empresa (não-destrutiva)
      const empresa = this.$store.state.auth.currenEmpresa;
      if (empresa) {
        const tipoEmpresa = parseInt(empresa.tab_103classificacao);
        if (tipoEmpresa === 924 || tipoEmpresa === 927 || tipoEmpresa === 928) {
          items = items.filter(x => x.id !== 10);
        }
        if (!empresa.menu_simples) {
          items = items.filter(x => x.id !== 50);
        }
      }

      return items;
    },
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
  },
};
</script>
